export default __webpack_public_path__ + "static/kaluga-1e7294d9d7d08796ccdf1714cb1a5a6d.jpg";